/**
 * SkipLinks Component - WCAG 2.2 Accessibility Requirement
 * 
 * Provides keyboard users with shortcuts to skip repetitive navigation
 * and jump directly to main content areas.
 */

export function SkipLinks() {
  return (
    <div className="sr-only focus-within:not-sr-only">
      <a
        href="#main-content"
        className="fixed top-2 left-2 z-50 px-4 py-2 
                   bg-primary text-primary-foreground
                   rounded-lg shadow-lg
                   focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2
                   min-h-[var(--touch-target-min)] 
                   flex items-center justify-center
                   font-medium transition-all motion-reduce:transition-none"
      >
        Skip to main content
      </a>
      <a
        href="#navigation"
        className="fixed top-2 left-2 mt-14 z-50 px-4 py-2 
                   bg-primary text-primary-foreground
                   rounded-lg shadow-lg
                   focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2
                   min-h-[var(--touch-target-min)] 
                   flex items-center justify-center
                   font-medium transition-all motion-reduce:transition-none"
      >
        Skip to navigation
      </a>
      <a
        href="#search"
        className="fixed top-2 left-2 mt-28 z-50 px-4 py-2 
                   bg-primary text-primary-foreground
                   rounded-lg shadow-lg
                   focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2
                   min-h-[var(--touch-target-min)] 
                   flex items-center justify-center
                   font-medium transition-all motion-reduce:transition-none"
      >
        Skip to search
      </a>
    </div>
  );
}
